var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 25,
    viewBox: "0 0 64 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 25,
    rx: 12.5,
    fill: "#8583FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1247_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2803 8.21967C24.5732 8.51256 24.5732 8.98744 24.2803 9.28033L16.7803 16.7803C16.4874 17.0732 16.0126 17.0732 15.7197 16.7803L12.7197 13.7803C12.4268 13.4874 12.4268 13.0126 12.7197 12.7197C13.0126 12.4268 13.4874 12.4268 13.7803 12.7197L16.25 15.1893L23.2197 8.21967C23.5126 7.92678 23.9874 7.92678 24.2803 8.21967Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9729 12.456V14.136H33.5689V12.456H31.9729ZM32.7529 8.4C31.1449 8.4 29.9809 9.324 29.9809 10.668C29.9809 11.988 31.1449 12.912 32.7529 12.912C34.3609 12.912 35.5249 11.988 35.5249 10.668C35.5249 9.324 34.3609 8.4 32.7529 8.4ZM32.7529 9.6C33.5209 9.6 34.0369 9.984 34.0369 10.668C34.0369 11.34 33.5209 11.724 32.7529 11.724C31.9969 11.724 31.4689 11.34 31.4689 10.668C31.4689 9.984 31.9969 9.6 32.7529 9.6ZM36.6649 7.968V16.44H38.2609V7.968H36.6649ZM37.6969 11.448V12.756H39.6529V11.448H37.6969ZM30.8449 17.592V18.876H38.6329V17.592H30.8449ZM30.8449 15.708V18.144H32.4529V15.708H30.8449ZM29.5849 15C31.4209 15 33.9409 14.964 36.1849 14.544L36.0769 13.404C33.8929 13.716 31.2889 13.728 29.4049 13.728L29.5849 15ZM43.036 14.436V17.052H44.596V14.436H43.036ZM46.552 14.424V17.052H48.112V14.424H46.552ZM40.492 16.548V17.844H50.548V16.548H40.492ZM41.62 8.676V9.936H47.836V11.112H41.644V14.244H43.228V12.36H49.42V8.676H41.62ZM41.644 13.572V14.856H49.672V13.572H41.644Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.1e545d00a53f9a4becbc1f69858dee96.svg";
export { ForwardRef as ReactComponent };